// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApplyInitialConfigurationMutationVariables = Types.Exact<{
  input: Types.ApplyInitialConfigurationInput;
}>;


export type ApplyInitialConfigurationMutation = { __typename?: 'Mutation', applyInitialConfiguration: { __typename?: 'ApplyInitialConfigurationResult', projectReadyPlanConfig: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
        | { __typename?: 'ReadyPlan', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'DesignPackage', id: string }
        | { __typename?: 'ProductOffering', id: string }
       | null | undefined, checkoutConfig?: { __typename?: 'CheckoutConfig', id: string } | null | undefined } } };


export const ApplyInitialConfigurationDocument = gql`
    mutation ApplyInitialConfiguration($input: ApplyInitialConfigurationInput!) {
  applyInitialConfiguration(input: $input) {
    projectReadyPlanConfig {
      id
      readyPlan {
        id
      }
      checkoutConfig {
        id
      }
    }
  }
}
    `;

/**
 * __useApplyInitialConfigurationMutation__
 *
 * To run a mutation, you first call `useApplyInitialConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyInitialConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyInitialConfigurationMutation, { data, loading, error }] = useApplyInitialConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyInitialConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyInitialConfigurationMutation, ApplyInitialConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplyInitialConfigurationMutation, ApplyInitialConfigurationMutationVariables>(ApplyInitialConfigurationDocument, options);
      }
export type ApplyInitialConfigurationMutationHookResult = ReturnType<typeof useApplyInitialConfigurationMutation>;
export type ApplyInitialConfigurationMutationResult = ApolloReactCommon.MutationResult<ApplyInitialConfigurationMutation>;